export const LIMIT_PEOPLEINSIDE = 30;
